import { useMemo } from "react";
import ButtonWithLoader from "../../../../../../common/components/ui/loading/ButtonLoading";
import "./IlevaActivate.scss"
import { FaCheckCircle } from "react-icons/fa";
import { useApproveIleva } from "@/modules/invoice/hook";

export default function IlevaActivate({ vehicleId, insuranceStatus }: { vehicleId: string, insuranceStatus: string}) {
  const approveIlevaMutation = useApproveIleva(vehicleId);
  const isProtected = insuranceStatus === "protected";

  const badgeColor = useMemo(() =>
    approveIlevaMutation.isSuccess || isProtected
      ? 'text-greenPrimary'
      : 'text-gray'
    , [approveIlevaMutation.isSuccess, isProtected])

  return (
    <div className="flex">
      <div className="w-[300px]">
        <h2 className="font-semibold">Clique aqui para enviar os dados para o Moto Clube:</h2>
      </div>
      <div className="flex items-center gap-4">
        <ButtonWithLoader
          type="button"
          disabled={approveIlevaMutation.isPending || isProtected}
          isLoading={approveIlevaMutation.isPending}
          onClick={() => approveIlevaMutation.mutate()}
        >
          Enviar Para Moto Clube
        </ButtonWithLoader>
        <FaCheckCircle size={24} className={`${badgeColor}`} />
      </div>
    </div>
  )
}

